// extracted by mini-css-extract-plugin
module.exports = {"notes":"SuggestedAreaForm_notes__1KzYI","infoNotes":"SuggestedAreaForm_infoNotes__e3_JY","infoBlock":"SuggestedAreaForm_infoBlock__2-G1L"};